import useStarterEnabled from '~pricing/hooks/useStarterEnabled';
import { EXPERIMENT_IDENTIFIERS } from '~server/routes/Pricing/experimentsConfig';
import { usePricingExperiments } from '~shared/hooks/usePricingExperiments';

import { getPackageSetBasedOnPath, getPnPRefreshPackages } from '~pricing/lib/lib-helpers';
import { PackageSet } from '~shared/types/pricing/package';

export default function usePackageSet(canonicalPath: string): { packageSet: PackageSet } {
  const { isStarterEnabled } = useStarterEnabled();
  const { uiExperiment, priceExperiment } = usePricingExperiments();

  // GROW-2197
  const isRowStarterAnnualEnabled =
    uiExperiment.hasAssignment && uiExperiment.treatmentName === EXPERIMENT_IDENTIFIERS.GROW_2197.treatment;

  // GROW-2529 Forms, GROW-2629 v2 Forms, price_test with major UI changes
  const isForms =
    uiExperiment.hasAssignment &&
    [
      EXPERIMENT_IDENTIFIERS.GROW_2629_FORMS_V2.treatment,
      EXPERIMENT_IDENTIFIERS.GROW_2529_FORMS.treatment1,
      EXPERIMENT_IDENTIFIERS.GROW_2529_FORMS.treatment2,
    ].includes(uiExperiment.treatmentName)
      ? uiExperiment
      : null;
  // END GROW-2529, GROW-2629

  // GROW-2792 PnP Refresh
  const isPnPRefresh =
    priceExperiment.hasAssignment && priceExperiment.treatmentName === EXPERIMENT_IDENTIFIERS.GROW_2792.treatment;

  function determinePackageSet(): PackageSet {
    return isPnPRefresh
      ? getPnPRefreshPackages()
      : getPackageSetBasedOnPath(canonicalPath, isForms, isStarterEnabled || isRowStarterAnnualEnabled);
  }

  return {
    packageSet: determinePackageSet(),
  };
}
